
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doctors/[slug]/reviews",
      function () {
        return require("private-next-pages/doctors/[slug]/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doctors/[slug]/reviews"])
      });
    }
  